import { z } from "zod";

import { CustomFieldSchema } from "@/domain/custom-field/models/custom-field-model";
import { MilestoneSchema } from "@/domain/milestone/models/milestone-model";
import { AssigneeSchema } from "@/domain/user/models/assignee-model";

import { TaskInstanceSchema } from "./task-instance.model";

export const TaskSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string().nullable().optional(),
  legacy_description: z.string().nullable().optional(),
  dueDate: z
    .union([z.date(), z.string(), z.null()])
    .transform((val) => {
      if (val === null || val === undefined) return null;
      if (val instanceof Date) return val;
      if (typeof val === "string") return new Date(val);
      return null;
    })
    .nullable()
    .optional(),
  dueOn: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  userId: z.string().nullable().optional(),
  milestoneId: z.string().nullable().optional(),
  taskInstanceList: z.array(z.lazy(() => TaskInstanceSchema)).optional(),
  workspaceId: z.string(),
  assignee: AssigneeSchema.nullable().optional(),
  assigneeList: z.array(AssigneeSchema).nullable().optional(),
  milestone: MilestoneSchema.nullable().optional(),
  completed: z.boolean().default(false),
  customFieldList: z.array(CustomFieldSchema).nullable().optional(),
});

export type Task = z.infer<typeof TaskSchema>;

export type NewTask = Omit<Task, "id" | "createdAt" | "updatedAt" | "userId"> & { description?: string | undefined };
